import activity from '@/assets/images/svg/activity.svg';
import apartment from '@/assets/images/svg/apartment.svg';
import banknote from '@/assets/images/svg/banknote.svg';
import calendarDate3 from '@/assets/images/svg/calendar-date-3.svg';
import calendarDate6 from '@/assets/images/svg/calendar-date-6.svg';
import calendarDate12 from '@/assets/images/svg/calendar-date-12.svg';
import celebration from '@/assets/images/svg/celebration.svg';
import certificateBadgeGalena from '@/assets/images/svg/certificate-badge-galena.svg';
import certificateBadge from '@/assets/images/svg/certificate-badge.svg';
import chatLike from '@/assets/images/svg/chat-like.svg';
import checkIcon from '@/assets/images/svg/check-icon.svg';
import emptyStateFeedbacks from '@/assets/images/svg/empty-state-feedbacks.svg';
import emptyStateManuallyAdded from '@/assets/images/svg/empty-state-manually-added.svg';
import error from '@/assets/images/svg/error.svg';
import externalLink from '@/assets/images/svg/external-link.svg';
import familyThin from '@/assets/images/svg/family-thin.svg';
import feedbackReplace from '@/assets/images/svg/feedback-replace.svg';
import feedbacksChange from '@/assets/images/svg/feedbacks-change.svg';
import feedbacksDelete from '@/assets/images/svg/feedbacks-delete.svg';
import galenaFaviconOutlined from '@/assets/images/svg/galena-favicon-outlined.svg';
import handMoney from '@/assets/images/svg/hand-money.svg';
import homeWork from '@/assets/images/svg/home-work.svg';
import interactiveSpace from '@/assets/images/svg/interactive-space.svg';
import map from '@/assets/images/svg/map.svg';
import payment from '@/assets/images/svg/payment.svg';
import robotDead from '@/assets/images/svg/robot-dead.svg';
import robotHappy from '@/assets/images/svg/robot-happy.svg';
import robotSad from '@/assets/images/svg/robot-sad.svg';
import rulerCrossPen from '@/assets/images/svg/ruler-cross-pen.svg';
import signPost from '@/assets/images/svg/sign-post.svg';
import sirenRounded from '@/assets/images/svg/siren-rounded.svg';
import success from '@/assets/images/svg/success.svg';
import teaCup from '@/assets/images/svg/tea-cup.svg';
import waiting from '@/assets/images/svg/waiting.svg';

export const iconMap = {
  activity,
  apartment,
  banknote,
  'calendar-date-3': calendarDate3,
  'calendar-date-6': calendarDate6,
  'calendar-date-12': calendarDate12,
  celebration,
  'certificate-badge-galena': certificateBadgeGalena,
  'certificate-badge': certificateBadge,
  'chat-like': chatLike,
  'check-icon': checkIcon,
  'empty-state-feedbacks': emptyStateFeedbacks,
  'empty-state-manually-added': emptyStateManuallyAdded,
  error,
  'external-link': externalLink,
  'family-thin': familyThin,
  'feedback-replace': feedbackReplace,
  'feedbacks-change': feedbacksChange,
  'feedbacks-delete': feedbacksDelete,
  'hand-money': handMoney,
  'home-work': homeWork,
  map,
  'interactive-space': interactiveSpace,
  payment,
  'robot-dead': robotDead,
  'robot-happy': robotHappy,
  'robot-sad': robotSad,
  'ruler-cross-pen': rulerCrossPen,
  'sign-post': signPost,
  'siren-rounded': sirenRounded,
  success,
  'tea-cup': teaCup,
  waiting,
  'galena-favicon-outlined': galenaFaviconOutlined,
} as const;

export type IconName = keyof typeof iconMap;
